<template>
  <div class="wrapper">
    <div>
      <img :src="'/assets/images/logo.png'" height="100" width="200" alt="logo" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreLoader',
  data(){
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>

